(ns builder.routes
  (:require [route-map.core :as route-map]))

(def routes {:. {:. :builder.index.model/ctx}
             "sso" {:. :builder.sso.model/ctx}
             "builder" {:. :builder.builder.model/ctx
                        [:q-id] {:. :builder.builder.model/ctx}}})
